import { css } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';
import { display } from '../../foundation/display';

export const progressBarStyles = css`
    ${display('inline-flex')}

    :host {
        position: relative;
        width: 100%;
        height: calc(${getToken('space-design-unit')} * 1px);
    }

    .progressBar {
        position: absolute;
        background: linear-gradient(
          to right,
            transparent,
            ${getToken('color-primary-base')},
            transparent
          );
        height: 100%;
        right:100%;
        left:0;
        width:0;
        animation: progressBarKey 2s linear infinite;
    }

    @keyframes progressBarKey {
        0% {
          left:0%;
          right:100%;
          width:0%;
        }
        10% {
          left:0%;
          right:75%;
          width:25%;
        }
        90% {
          right:0%;
          left:75%;
          width:25%;
        }
        100% {
          left:100%;
          right:0%;
          width:0%;
        }
      }
`;
